export default {
  computed: {
    computedDisabledDateFrom() {
      if (!this.end) return {};
      return {
        from: new Date(this.end)
      };
    },
    computedDisabledDateTo() {
      const epoch = 8640000;
      return {
        to: new Date(this.start - epoch)
      };
    }
  },
  methods: {
    handleCalendarValues(value) {
      if (!value) {
        this.$refs.start.clearDate();
        this.$refs.end.clearDate();
      }
    }
  }
};